import React, { useContext } from 'react';
import LanguageContext from '../LanguageContext';
import {
  buildMaintenanceAnnouncementDisplay,
  isMaintenanceAnnouncementVisible,
} from '../utils/serviceAnnouncement';

function MaintenanceAnnouncementBanner({ announcement, now = new Date() }) {
  const { language, selectedLanguage } = useContext(LanguageContext);
  const locale = selectedLanguage === 'fr' || language === 'fr' ? 'fr' : 'en';
  const display = buildMaintenanceAnnouncementDisplay(announcement, { now, locale });

  if (!display || !isMaintenanceAnnouncementVisible(announcement)) {
    return null;
  }

  return (
    <div className="govuk-width-container govuk-!-margin-top-4">
      <div
        className="govuk-notification-banner"
        role="region"
        aria-labelledby="service-maintenance-banner-title"
        data-module="govuk-notification-banner"
      >
        <div className="govuk-notification-banner__header">
          <h2 className="govuk-notification-banner__title" id="service-maintenance-banner-title">
            {display.title}
          </h2>
        </div>
        <div className="govuk-notification-banner__content" lang={locale}>
          <p className="govuk-notification-banner__heading">{display.heading}</p>
          {display.body ? <p className="govuk-body">{display.body}</p> : null}
        </div>
      </div>
    </div>
  );
}

export default MaintenanceAnnouncementBanner;
